// @ts-nocheck
// Flat "Profile settings" page — edits the same Birch preference metafields
// as the profile-setup wizard, but as a single page with one Save action.
// Deliberately does not share code with birch-profile.js: that file drives a
// live, unversioned onboarding flow against a backend we can't inspect from
// this repo, so it's safer to keep this page's (much simpler) logic
// independent rather than risk regressing onboarding via a shared module.
(function () {
  'use strict';

  var profileData = loadServerData();

  var saveBtn = document.getElementById('bps-save-btn');
  var msgEl   = document.getElementById('bps-save-msg');

  function init() {
    var chipsEls = document.querySelectorAll('.bps-chips');
    if (!chipsEls.length && !saveBtn) return;

    wireChips();
    wireDateAndSelect();
    wireBabyStageConditional();
    restoreFromServerData();
    wireSave();
  }

  // ─── Load server-side saved metafields ───────────────────────────────────
  function loadServerData() {
    var src = window.__birchProfileSaved;
    if (!src || typeof src !== 'object') return {};
    var out = {};
    Object.keys(src).forEach(function (k) {
      var v = src[k];
      if (v === null || v === undefined || v === '') return;
      if (Array.isArray(v) && v.length === 0) return;
      out[k] = v;
    });
    return out;
  }

  // ─── Chip selectors ──────────────────────────────────────────────────────
  function wireChips() {
    document.querySelectorAll('.bps-chips').forEach(function (chipsEl) {
      var isMulti = chipsEl.dataset.type === 'multi';
      var max = parseInt(chipsEl.dataset.max, 10) || Infinity;

      chipsEl.querySelectorAll('.bps-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (isMulti) {
            var sel = chipsEl.querySelectorAll('.bps-chip--selected');
            if (!chip.classList.contains('bps-chip--selected') && sel.length >= max) return;
            chip.classList.toggle('bps-chip--selected');
          } else {
            chipsEl.querySelectorAll('.bps-chip').forEach(function (c) {
              c.classList.remove('bps-chip--selected');
            });
            chip.classList.add('bps-chip--selected');
          }
          collectChips(chipsEl);
        });
      });
    });
  }

  function collectChips(chipsEl) {
    var field   = chipsEl.dataset.field;
    var isMulti = chipsEl.dataset.type === 'multi';
    var selected = chipsEl.querySelectorAll('.bps-chip--selected');
    profileData[field] = isMulti
      ? Array.from(selected).map(function (c) { return c.dataset.value; })
      : (selected.length ? selected[0].dataset.value : null);
  }

  // ─── Date / select inputs ────────────────────────────────────────────────
  function wireDateAndSelect() {
    document.querySelectorAll('input[type="date"][data-field]').forEach(function (el) {
      el.addEventListener('change', function () {
        profileData[el.dataset.field] = el.value;
      });
    });

    document.querySelectorAll('select[data-field]').forEach(function (el) {
      el.addEventListener('change', function () {
        profileData[el.dataset.field] = el.value;
      });
    });
  }

  // ─── Baby stage → show/hide date field ──────────────────────────────────
  function wireBabyStageConditional() {
    var stageChips = document.querySelector('[data-field="baby_stage"]');
    if (!stageChips) return;

    stageChips.querySelectorAll('.bps-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        applyStageVisibility(chip.dataset.value);
      });
    });
  }

  function applyStageVisibility(stage) {
    var dueDateField = document.getElementById('bps-due-date-field');
    var dobField     = document.getElementById('bps-dob-field');
    var budgetField   = document.getElementById('bps-budget-range-field');
    if (!dueDateField || !dobField) return;

    if (stage === 'expecting') {
      dueDateField.style.display = '';
      dobField.style.display = 'none';
      if (budgetField) budgetField.style.display = '';
    } else if (['newborn', '0_3mo', '3_6mo', '6_12mo'].includes(stage)) {
      dueDateField.style.display = 'none';
      dobField.style.display = '';
      if (budgetField) budgetField.style.display = 'none';
    } else {
      dueDateField.style.display = 'none';
      dobField.style.display = 'none';
      if (budgetField) budgetField.style.display = 'none';
    }
  }

  // ─── Prefill fields from saved metafields ────────────────────────────────
  function restoreFromServerData() {
    if (!profileData || !Object.keys(profileData).length) return;

    document.querySelectorAll('.bps-chips').forEach(function (chipsEl) {
      var field   = chipsEl.dataset.field;
      var isMulti = chipsEl.dataset.type === 'multi';
      var saved   = profileData[field];
      if (!saved) return;
      chipsEl.querySelectorAll('.bps-chip').forEach(function (chip) {
        var match = isMulti
          ? (Array.isArray(saved) && saved.includes(chip.dataset.value))
          : (chip.dataset.value === saved);
        chip.classList.toggle('bps-chip--selected', match);
      });
    });

    document.querySelectorAll('input[type="date"][data-field]').forEach(function (el) {
      if (profileData[el.dataset.field]) el.value = profileData[el.dataset.field];
    });
    document.querySelectorAll('select[data-field]').forEach(function (el) {
      if (profileData[el.dataset.field]) el.value = profileData[el.dataset.field];
    });

    if (profileData.baby_stage) applyStageVisibility(profileData.baby_stage);
  }

  // ─── Build metafields payload ─────────────────────────────────────────────
  function buildMetafields() {
    var mf  = [];
    var idx = 0;

    function add(key, value, type) {
      if (value === null || value === undefined || value === '') return;
      mf.push({ idx: idx++, key: key, value: String(value), type: type || 'single_line_text_field' });
    }

    add('baby_stage',        profileData.baby_stage);
    add('due_date',          profileData.due_date);
    add('baby_dob',          profileData.baby_dob);
    add('is_first_baby',     profileData.is_first_baby);
    // CANONICAL KEY. This used to write `baby_count`, while every reader — the
    // AI worker's CustomerProfile, update_profile_fact, every multiples rule —
    // looked at `baby_count_str`, so the wizard's answer never reached the
    // registry builder. The worker also reads the old key as a fallback, so
    // profiles saved before this fix keep working; nothing needs migrating.
    add('baby_count_str',    profileData.baby_count_str !== 'prefer_not' ? profileData.baby_count_str : null);

    add('home_type',   profileData.home_type);
    add('travel_freq', profileData.travel_freq);

    if (profileData.priority_tags && profileData.priority_tags.length) {
      add('priority_tags', JSON.stringify(profileData.priority_tags), 'json');
    }
    add('price_tier',   profileData.price_tier);
    add('budget_range', profileData.budget_range);
    if (profileData.splurge_cats && profileData.splurge_cats.length) {
      add('splurge_cats', JSON.stringify(profileData.splurge_cats), 'json');
    }

    // Reaching this page's Save action means the customer has an
    // established profile — always mark it complete, mirroring the wizard
    // reaching its final review step.
    add('profile_complete',   'true');
    add('profile_updated_at', new Date().toISOString());

    return mf;
  }

  // ─── Submit via Admin API proxy (same endpoint the wizard already uses) ──
  var PROFILE_API_URL = (function () {
    var h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') {
      try {
        var ov = new URLSearchParams(window.location.search).get('profile_api')
          || (window.localStorage && localStorage.getItem('birch_profile_api'))
          || window.BIRCH_PROFILE_API;
        if (ov) return ov;
      } catch (_) { /* no-op */ }
      return 'http://localhost:8789/save-profile';
    }
    return '/apps/birch-profile/save-profile';
  })();

  function wireSave() {
    if (!saveBtn) return;
    saveBtn.addEventListener('click', function () {
      var customerId = window.__birchCustomerId;
      if (!customerId) {
        showMsg('Not signed in — please refresh and try again.', true);
        return;
      }

      saveBtn.disabled = true;
      saveBtn.textContent = 'Saving…';

      fetch(PROFILE_API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          customer_id: customerId,
          metafields:  buildMetafields()
        })
      })
        .then(function (res) {
          if (res.ok) {
            showMsg('Saved.', false);
          } else {
            res.text().then(function (t) { console.error('Save error body:', t); });
            showMsg('Save failed (' + res.status + '). Please try again.', true);
          }
        })
        .catch(function (err) {
          console.error('Profile settings save error:', err);
          showMsg('Could not connect — please check your internet and try again.', true);
        })
        .finally(function () {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Save changes';
        });
    });
  }

  function showMsg(text, isError) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'bps-savebar__msg ' + (isError ? 'bps-savebar__msg--error' : 'bps-savebar__msg--success');
    msgEl.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
